module.exports = __webpack_public_path__ + "static/img/apopointCMS.752c86f3.jpg";